//
// Copyright (c) 2024 Comcast
//

import PropTypes from 'prop-types'
import ToggleSwitch from 'components/Shared/ToggleSwitch/Index'
import { Field } from 'react-final-form'
import styled from 'styled-components'
import colors from 'components/utils/colors'

const ToggleSwitchLabeled = styled.div`
  display: flex;
  align-items: center;
`

const ToggleLabel = styled.div`
  font-size: 14px;
  padding-left: 8px;
  color: ${props => props.isActive ? colors.secondary20 : colors.secondary60};
  cursor: ${props => props.isDisabled ? 'default' : 'pointer'};
  user-select: none;
`

const SwitchField = ({ name, disabled, checkboxLabel, hideLabelWhenFalse }) => {
  return (
    <Field
      name={name}
      type='input'
    >
      {({ input, meta }) => {
        const showLabel = !hideLabelWhenFalse || input.value
        const value = !!input.value
        return (
          <ToggleSwitchLabeled>
            <ToggleSwitch
              value={value}
              onChange={input.onChange}
              disabled={disabled}
            />
            {showLabel && (
              <ToggleLabel
                isActive={value && !disabled}
                isDisabled={disabled}
                onClick={() => !disabled && input.onChange(!value)}
              >
                {checkboxLabel}
              </ToggleLabel>
            )}
          </ToggleSwitchLabeled>
        )
      }}
    </Field>
  )
}

SwitchField.propTypes = {
  name: PropTypes.string,
  disabled: PropTypes.bool,
  checkboxLabel: PropTypes.string,
  hideLabelWhenFalse: PropTypes.bool,
}

export default SwitchField
